import React, { useState, useEffect } from 'react';
import { getBrandName } from 'utils/brand';
import css from "./style.scss";
import classNames from "classnames";
import { ReactSVG } from 'react-svg';
import { withRouter } from 'react-router-dom';
import downFullArrow from '../../../assets/images/account-page/down-full-arrow.svg'
import numberFormat from 'utils/number/format';
import CreditCardDropdown from '../components/CreditCardDropdown';
import { connect, useSelector, useDispatch } from 'react-redux';
import { fetchPlanDueAmount, selectCardList, selectPlanDetails, selectUserId, upgradeDowngradeManagePlan, selectTeamCounts, isLegacyAccountPlan, getPlanDetails } from '../../../data/user';

import currencyFormat from 'utils/currency/numberToPrice';
import EssentialsIcon from "assets/images/account-page-plan-essentials.svg";
import ProIcon from "assets/images/account-page-plan-pro.svg";
import EliteIcon from "assets/images/account-page-plan-elite.svg";
import LegacyIcon from "assets/images/account-page-plan-legacy.svg";
import * as moment from 'moment';
import CVV99Modal from "../components/cvv99Modal";
import LeaveMessagePopup from '../modals/LeaveMessage';
import { planInclusion } from 'data/user/constants';
import DNCPolicyModal from '../../components/DNCPolicyModal';
import LoadablePanel from 'components/hoc/loadable/Panel';
import ErrorDisplay from '../components/ErrorDisplay';
import AccountLogo from '../components/AccountLogo';
import { refreshSubscriptionCards } from '../refreshSubscriptionCards';

const ReviewAndSubmit = (props) => {
  const [dueAmountDetails, setDueAmountDetails] = useState(0);
  const [successful, setSuccessful] = useState(false); // Default selected plan
  const [errorFetched, setErrorFetched] = useState(0);
  const dispatch = useDispatch();
  const goToPlan = () => {
    props.history.push(`/accountnew/plan`);
  }
  const counts = useSelector(selectTeamCounts);
  const isLegacyAccount = useSelector(isLegacyAccountPlan);

  useEffect(() => {
    const handleBeforeUnload = (e) => {
      e.preventDefault();
      e.returnValue = "You have unsaved changes. Are you sure you want to refresh?"; 
      sessionStorage.setItem("redirectToPlan", "true");
      return ""
    };
    if(planDetails?.selectedManagePlan?.id){
      getPlanDueAmount();
    }
    window.addEventListener("beforeunload", handleBeforeUnload);
    if (sessionStorage.getItem("redirectToPlan") === "true") {
      sessionStorage.removeItem("redirectToPlan");
      props.history.push("/accountnew/landing");
    }
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  const planDetails = useSelector(selectPlanDetails)?.toJS();
  const cardList = useSelector(selectCardList);
  const userId = useSelector(selectUserId);

  const [selectedCard, setSelectedCard] = useState(cardList[0] || {}); // Default selected card
  const [showCVVModal, setShowCVVModal] = useState(false);

  
  const getIcon = (planName) => {
    if (planName) {
      if (planName.includes("Essentials")) return EssentialsIcon;
      else if (planName.includes("Pro")) return ProIcon;
      else return EliteIcon;
    } else return "";
  };
  
  const getPlanName = () => {
    if (isLegacyAccount) return "Legacy";
    if (planDetails?.accountEnrolledPlans && planDetails?.accountEnrolledPlans.length > 0) {
      const selectedPlan = planDetails.availableUserPlans.find(plan => plan.id === planDetails?.accountEnrolledPlans[0]?.planId);
      if (selectedPlan && selectedPlan?.name) return selectedPlan.name.split(' ')[0];
      return "";
    }
    return "";
  }
  
  const handleCardChange = (selectedOption) => {
    setSelectedCard(selectedOption);
  };

  const gotoPlanDetails =()=>{
    props.history.push(`/accountnew/plan`);
  }

  const getPlanDueAmount = async () => {
    setDueAmountDetails({});
    const payload = {
      userId,
      currentPlanId: planDetails?.accountEnrolledPlans[0]?.planId,
      newPlanId: planDetails?.selectedManagePlan?.id,
    };

    try {
      const response = await fetchPlanDueAmount(payload) ;
      if (response.success) {
        setDueAmountDetails(response.data);
         setErrorFetched(0);
      } else {
        console.error(`plan due amount failed:`, response.error);
        props.leaveMessagePopup({
          title: "Error fetching due amount",
          message: "An unexpected error occurred while fetching the due amount. Please try again later.",
          yesLable: 'Close',
          cancelLable: '',
          yesRedirect: () => null,
        });
        setErrorFetched(prevCount => prevCount + 1);
      }
    } catch (error) {
      console.error("Unexpected error:", error);
      props.leaveMessagePopup({
        title: "Error fetching due amount",
        message: "An unexpected error occurred while fetching the due amount. Please try again later.",
        yesLable: 'Close',
        cancelLable: '',
        yesRedirect: () => null,
      });
      setErrorFetched(prevCount => prevCount + 1);
    }
  }
  const updateManagePlan = async ({ cardCode = "" }) => {
    const url = isLegacyAccount ? "upgrade" : (planDetails?.selectedManagePlan?.planAmount >= planDetails?.accountEnrolledPlans[0]?.amount ? "upgrade" : "downgrade");
    const payload = {
      userId,
      currentPlanId: planDetails?.accountEnrolledPlans[0]?.planId,
      upgradePlanId: planDetails?.selectedManagePlan?.id,
      approvedAmount: dueAmountDetails?.dueAmount,
      paymentMethodId: selectedCard?.paymentMethodId,
      savesAndExports: planDetails?.selectedManagePlan?.savedPropertyLimit
    };

    if (Number(planDetails?.selectedManagePlan?.planAmount) > 99 && !cardCode) {
      setShowCVVModal(true);
      return;
    }
    if (cardCode) {
      payload.cardCode = cardCode;
    }
    try {
      const response = await upgradeDowngradeManagePlan(url, payload) ;
      if (response.success) {
        console.log("Update plan success:", response);
        setSuccessful(true);
        // ATAI-504: a plan change can drop the Investor Outreach add-on (and move Connect), and its
        // subscription state is cached in the store. Refresh it here, not in goToAccount, so the
        // Investor Outreach route is also correct when the user leaves through the sidebar.
        refreshSubscriptionCards(dispatch, userId);
        if (cardCode) {
          setShowCVVModal(false);
        }
      } else {
        setSuccessful(false);
        setShowCVVModal(false);
        console.error(`Update plan failed:`, response.error);
        props.leaveMessagePopup({
          title: "Error",
          message: response.error,
          yesLable: 'Close',
          cancelLable: '',
          yesRedirect: () => null,
        });
      }
    } catch (error) {
      setSuccessful(false);
      setShowCVVModal(false);
      console.error("Unexpected error:", error);
      props.leaveMessagePopup({
        title: "Error updating plan",
        message: "An unexpected error occurred while updating the plan. Please try again later.",
        yesLable: 'Close',
        cancelLable: '',
        yesRedirect: () => null,
      });
    }
  }

  const goToAccount = () => {
    dispatch(getPlanDetails(userId));
    props.history.push(`/accountnew/landing`);
  }
  
  const getPlanInclusions = (plan, type) => {
    return planInclusion?.[type]?.[plan] || [];
  };

  const PlanInclusionsList = ({ planName, type, plan, className = null }) => {
    
    if(plan && plan.planMonthlyAmount == 99.00 && plan.planFrequency == 'Annual' && planName == 'Essentials')
      planName = "Essentials_99"
     else {
      const selectedPlan = planDetails?.availableUserPlans?.find((p) => p?.id === plan?.planId);
      if (selectedPlan && selectedPlan?.planMonthlyAmount === 99.0 && selectedPlan?.planFrequency === "Annual" && selectedPlan?.name?.includes("Essentials")) {
        planName = "Essentials_99";
      }
    }

    const includedItems = getPlanInclusions(planName, type)?.included || [];
    
    return (
      <>
        {includedItems.length > 0 ? (
          includedItems.map((item, index) => (
            <li key={index} className={css.clsPlansItem}>
              <span className={classNames(css.clsPlansCircle, className)}></span>
              <h5 className={css.clsPlansListName}>{item}</h5>
            </li>
          ))
        ) : (
          <li className={css.clsPlansItem}>NONE</li>
        )}
      </>
    );
  };

  const PlanAddonList = ({ planName, type, className = null }) => {
    
    const getPlanData  = getPlanInclusions(planName, type);
    const addOnAccount = counts.fullAccessCount - (getPlanData?.teamMembers ? getPlanData?.teamMembers : 0);
  
    return (
      <>
        {addOnAccount > 0 ? (
          <li className={css.clsPlansItem}>
            <span className={classNames(css.clsPlansCircle, className)}></span>
            <h5 className={css.clsPlansListName}>{addOnAccount} Full Access Team Members</h5>
          </li>
        ) : (
          <li className={css.clsPlansItem}>NONE</li>
        )}
      </>
    );
  };


  return (
    <div className={css.clsInnerMainBody}>
      <div className={css.clsInnerPage}>
        <div className="container">
          <div className={css.clsPlanReviewPaySec}>
            <div className={css.clsPlansCardsGrp}>
              <div className={css.clsPlanReviewPayCard1}>
                <div className={css.clsPlanBtnGrp}>
                  <button className={css.clsPlanBtn}>OLD PLAN</button>
                </div>
                <div className={css.clsPlanDetails}>
                  <div className={css.clsPlanDetailsGrp1}>
                    <div className={css.clsPlanICons}>
                      <ReactSVG src={isLegacyAccount ? LegacyIcon : getIcon(getPlanName())} className={css.planIcon} />
                    </div>
                    <h4 className={isLegacyAccount ? css.clsLegacyPlanHeading : css.clsPlanHeading}>{getPlanName()}</h4>
                  </div>

                  <div className={css.clsPlanDetailsGrp2}>
                    <div className="clearfix">
                      <h4 className={css.clsTxtLine1}>TYPE</h4>
                      <h4 className={css.clsTxtLine2}>{planDetails?.accountEnrolledPlans?.length > 0 && planDetails?.accountEnrolledPlans[0]?.currentAnnual ? "Annual" : "Monthly"}</h4>
                    </div>
                    <span className={css.clsBorder}></span>
                    <div className="clearfix">
                      <h4 className={css.clsTxtLine1}>SAVES & EXPORTS</h4>
                      <h4 className={css.clsTxtLine2}>{planDetails?.accountEnrolledPlans?.length > 0 && numberFormat(planDetails?.accountEnrolledPlans[0]?.quantity)}<sub>/mo</sub></h4>
                    </div>
                  </div>
                </div>

                <div className={css.clsPlanIncludedSec}>
                  <ul className={css.clsPlansList}>
                    <li className={css.clsPlansItem}>
                      <h3 className={css.clsPlansHeading}>Included</h3>
                    </li>
                    <PlanInclusionsList planName={getPlanName()} type={planDetails?.accountEnrolledPlans[0]?.currentAnnual ? "Annual" : "Monthly"} plan={planDetails?.accountEnrolledPlans[0]} />
                  </ul>
                </div>

                <div className={css.clsPlanAddedOnSec}>
                  <ul className={css.clsPlansList}>
                    <li className={css.clsPlansItem}>
                      <h3 className={css.clsPlansHeading}>Added-On</h3>
                    </li>
                    {/* <li className={css.clsPlansItem}>
                      <span className={classNames(css.clsPlansCircle, css.clsPlansCircleNon)}></span>
                      <h5 className={css.clsPlansListName}>Lead Automator 50K</h5>
                    </li>
                    <li className={css.clsPlansItem}>
                      <span className={classNames(css.clsPlansCircle, css.clsPlansCircleNon)}></span>
                      <h5 className={css.clsPlansListName}>2 Full Access Team Members</h5>
                    </li> */}
                    <PlanAddonList planName={getPlanName()} type={planDetails?.accountEnrolledPlans[0]?.currentAnnual ? "Annual" : "Monthly"}  />
                  </ul>
                </div>
              </div>
              <div className="text-center">
                <ReactSVG src={downFullArrow} />
              </div>
              <div className={css.clsPlanReviewPayCard1}>
                <div className={css.clsPlanBtnGrp}>
                  <button className={classNames(css.clsPlanBtn, css.clsBtnOrng)}>NEW PLAN</button>
                </div>
                <div className={css.clsPlanDetails}>
                  <div className={css.clsPlanDetailsGrp1}>
                    <div className={css.clsPlanICons}>
                      <ReactSVG src={getIcon(planDetails?.selectedManagePlan?.name)} className={css.planIcon} />
                    </div>
                    <h4 className={css.clsPlanHeading}>{planDetails?.selectedManagePlan?.name ? planDetails?.selectedManagePlan?.name?.split(' ')[0] : ""}</h4>
                  </div>

                  <div className={css.clsPlanDetailsGrp2}>
                    <div className="clearfix">
                      <h4 className={css.clsTxtLine1}>TYPE</h4>
                      <h4 className={css.clsTxtLine2}>{planDetails?.selectedManagePlan?.planFrequency}</h4>
                    </div>
                    <span className={css.clsBorder}></span>
                    <div className="clearfix">
                      <h4 className={css.clsTxtLine1}>SAVES & EXPORTS</h4>
                      <h4 className={css.clsTxtLine2}>{numberFormat(planDetails?.selectedManagePlan?.savedPropertyLimit)}<sub>/mo</sub></h4>
                    </div>
                  </div>
                </div>

                <div className={css.clsPlanIncludedSec}>
                  <ul className={css.clsPlansList}>
                    <li className={css.clsPlansItem}>
                      <h3 className={css.clsPlansHeading}>Included</h3>
                    </li>
                    
                    <PlanInclusionsList planName={planDetails?.selectedManagePlan?.name ? planDetails?.selectedManagePlan?.name?.split(' ')[0] : ""} type={planDetails?.selectedManagePlan?.planFrequency} plan={planDetails?.selectedManagePlan}  />
                  </ul>
                </div>

                <div className={css.clsPlanAddedOnSec}>
                  <ul className={css.clsPlansList}>
                    <li className={css.clsPlansItem}>
                      <h3 className={css.clsPlansHeading}>Added-On</h3>
                    </li> 
                    {/* <li className={css.clsPlansItem}>
                      <span className={classNames(css.clsPlansCircle, css.clsPlansCircleNon)}></span>
                      <h5 className={css.clsPlansListName}>None</h5>
                    </li> */}
                    <PlanAddonList planName={planDetails?.selectedManagePlan?.name ? planDetails?.selectedManagePlan?.name?.split(' ')[0] : ""} type={planDetails?.accountEnrolledPlans[0]?.currentAnnual ? "Annual" : "Monthly"}  />
                  </ul>
                </div>
              </div>
            </div>

            {!successful ? <div className={css.clsPlanReviewPayCard2}>
              <h3 className={css.clsPlanReviewHeading}>
                <AccountLogo/>
              Review And Confirm Changes</h3>
              <div className={css.clsPlanReviewTimelineContainer}>
              {errorFetched > 0 ? (
                  <ErrorDisplay errorFetched={errorFetched} onReload={gotoPlanDetails} />
               ) :
              !dueAmountDetails || dueAmountDetails?.dueAmount === null || dueAmountDetails?.dueAmount === undefined ?
                  <div style={{ padding: "50px" }}>
                    <LoadablePanel loading={!dueAmountDetails || dueAmountDetails?.dueAmount === null || dueAmountDetails?.dueAmount === undefined}></LoadablePanel>
                  </div>
                :
                <div className={css.clsPlanReviewTimeline}>
                  <div className={css.clsPlanTimelineItem}>
                    <div className={css.clsPlanTimelineDot}></div>
                    <div className={css.clsPlanTimelineContent}>
                      <div className={css.clsPlanTimelineHead}>
                        <h4 className={css.clsPlanTimelineLabel}>Due Today</h4>
                        {planDetails?.selectedManagePlan?.planAmount >= planDetails?.accountEnrolledPlans[0]?.amount && <h5 className={css.clsPlanTimelinePrice}>{currencyFormat(dueAmountDetails?.dueAmount)}</h5>}
                      </div>
                      <p className={css.clsPlanTimelineDescription}>New plan begins. {dueAmountDetails?.daysUntilNextBillingCycle} days until next billing cycle.</p>
                    </div>
                  </div>

                  <div className={css.clsPlanTimelineLine}></div>

                  <div className={css.clsPlanTimelineItem}>
                    <div className={css.clsPlanTimelineDot}></div>
                    <div className={css.clsPlanTimelineContent}>
                      <div className={css.clsPlanTimelineHead}>
                        <h4 className={css.clsPlanTimelineLabel}>Starting {moment(dueAmountDetails?.firstBillingDate)?.format("MMMM D, YYYY")}</h4>
                        {dueAmountDetails?.nextBillingAmount > 0 && <h5 className={css.clsPlanTimelinePrice}>{currencyFormat(dueAmountDetails?.nextBillingAmount)}/{dueAmountDetails?.nextBillingFrequency}</h5>}
                      </div>
                    </div>
                  </div>


                </div>
              }
              </div>

              <div className={css.pb_48}>
                <div className={css.clsPlanReviewPMCard}>
                  <h4 className={css.clsPlanReviewPMCardHeading}>Payment Method</h4>
                    <CreditCardDropdown
                      tag={false}
                      options={cardList}
                      paymentMethodType={'Subscription'}
                      onChange={(selectedOption) => handleCardChange(selectedOption)}
                    />
                </div>
              </div>

              <div className={css.clsPlanReviewContentPara}>
                <p className={classNames(css.clsPara, css.mb_16)}>
                  <span className={css.text_b}>Starting on {moment(dueAmountDetails?.firstBillingDate)?.format("MMMM D, YYYY")} you’ll be charged {
                    currencyFormat(dueAmountDetails?.nextBillingAmount)} automatically every {dueAmountDetails?.nextBillingFrequency} until you cancel. </span>
                    This does not include any other {getBrandName()} services you may be subscribed to. Your price may change as described in the 
                     <a target="_blank" href="https://www.propstream.com/terms-of-use" className={css.terms_conditions}> PropStream Terms and Conditions.</a>
                </p>
                <p className={css.clsPara}>
                  By clicking “Confirm Changes” you agree to the <a target="_blank" href="https://www.propstream.com/terms-of-use" className={css.terms_conditions}>PropStream Terms and Conditions</a>
                  <span> and </span><span role="button" className={css.terms_conditions} onClick={()=>{
                    props.dncPolicy({});
                  }}>DNC Policy</span>.
                </p>
              </div>
            </div>
            : <SuccessfulFlow planDetails={planDetails} dueAmountDetails={dueAmountDetails} />
            }

          </div>
        </div>
      </div>

      <div className={css.clsInnerFooter}>
        {!successful ? (
          <>
            <button className={classNames(css.btn_xl, css.btn_primary, css.clsBtnPrimaryGreen)} onClick={goToPlan}> Back to Tiers </button>
            <button className={classNames(css.btn_xl, css.btn_primary, css.clsBtnOrng)} disabled={!dueAmountDetails || dueAmountDetails?.dueAmount === null || dueAmountDetails?.dueAmount === undefined || !planDetails?.selectedManagePlan?.id} onClick={updateManagePlan}> Confirm Changes </button>
          </>
        ) : (
          <button className={classNames(css.btn_xl, css.btn_primary, css.clsBtnOrng)} onClick={() =>goToAccount()}> Return to Account Home</button>
        )}
      </div>

      {showCVVModal && <CVV99Modal
          showCVVModal={showCVVModal} cardEnding={selectedCard?.cardEnding} cvvLength={selectedCard?.cardCVVLength} handleSubmitCVV={updateManagePlan} 
          handleCancel={() => setShowCVVModal(false)} handleClose={() => setShowCVVModal(false)}  />}
      
    </div>
  )
}

const SuccessfulFlow = ({ planDetails, dueAmountDetails }) => {
  return (
    <div className="col-lg-5">
    <div className={css.clsPlanReviewPayCard2}>
      <h3 className={css.clsPlanReviewHeading}>
        <AccountLogo/>
      Changes Successful</h3>
      <div className={css.clsPlanReviewTimelineContainer}>
        <div className={css.clsPlanReviewTimeline}>
          <div className={css.clsPlanTimelineItem}>
            <div className={css.clsPlanTimelineDot}></div>
            <div className={css.clsPlanTimelineContent}>
              <div className={css.clsPlanTimelineHead}>
                <h4 className={css.clsPlanTimelineLabel}>Paid Today</h4>
                {planDetails?.selectedManagePlan?.planAmount >= planDetails?.accountEnrolledPlans[0]?.amount && <h5 className={css.clsPlanTimelinePrice}>{currencyFormat(dueAmountDetails?.dueAmount)}</h5>}
              </div>
              <p className={css.clsPlanTimelineDescription}>New Plan begins. {dueAmountDetails?.daysUntilNextBillingCycle} days until next billing cycle.</p>
            </div>
          </div>

          <div className={css.clsPlanTimelineLine}></div>

          <div className={css.clsPlanTimelineItem}>
            <div className={css.clsPlanTimelineDot}></div>
            <div className={css.clsPlanTimelineContent}>
              <div className={css.clsPlanTimelineHead}>
                <h4 className={css.clsPlanTimelineLabel}>Starting {moment(dueAmountDetails?.firstBillingDate)?.format("MMMM D, YYYY")}</h4>
                {dueAmountDetails?.nextBillingAmount > 0 && <h5 className={css.clsPlanTimelinePrice}>{currencyFormat(dueAmountDetails?.nextBillingAmount)}/{dueAmountDetails?.nextBillingFrequency}</h5>}
              </div>
            </div>
          </div>  
        </div>
      </div>
    </div>
  </div>
  )
}

export default withRouter(connect(null, {
  leaveMessagePopup: LeaveMessagePopup.open,
  dncPolicy: DNCPolicyModal.open

})(ReviewAndSubmit));
